<template>
  <div class="know-box">
    <!-- 页面元素 -->
    <div class="box-title u-flex u-flex-col u-col-center">
      <div class="u-flex">
        <div class="left"></div>
        <div class="right">信用改变生活</div>
      </div>
      <p>正规持牌金融机构，应你之急</p>
    </div>
    <div class="box-main">
      <div
        class="know-content-box"
        v-for="(item, index) in contentList"
        :key="index"
      >
        <!-- 标题1 -->
        <div class="u-flex u-col-stretch know-title">
          <div class="u-flex-1 u-flex-col u-row-between know-title-font">
            <div class="font-tit">{{ item.top.content }}</div>
            <div class="font-ntit" v-if="item.top.des">
              {{ item.top.des }}
            </div>
          </div>
        </div>
        <!-- 内容1 -->
        <div
          class="know-cont know-cont1-box"
          v-for="(val, index) in item.content"
          :key="index + 'con'"
        >
          <!-- 在首页点击提升额度 -->
          <div class="u-flex u-col-top know-cont1">
            <div class="know-cont-tit">
              <span class="text">{{ index + 1 }}</span>
            </div>
            <div class="know-cont1-right">
              <div class="know-cont-tit">{{ val.title }}</div>
              <div class="know-cont1-cont">
                {{ val.content }}
              </div>
            </div>
          </div>
          <!-- 完成资料提交 -->
          <!-- <div class="u-flex u-col-top know-cont1">
          <div class="know-cont-tit">②</div>
          <div class="know-cont1-right">
            <div class="know-cont-tit">完成资料提交</div>
            <div class="know-cont1-cont">
              信息采集完成后点击页面中【下一步】按钮提交您的贷款申请，您的贷款申请预计再5分钟内可以完成审核，在此期间建议您开启通知权限，及时获知审核结果。
            </div>
          </div>
        </div> -->
          <!-- 完成提款 -->
          <!-- <div class="u-flex u-col-top know-cont1">
          <div class="know-cont-tit">③</div>
          <div class="know-cont1-right">
            <div class="know-cont-tit">完成提款</div>
            <div class="know-cont1-cont">
              额度审核完成后，在首页点击【提款】按钮，绑定您的银行卡，配合安全方面考虑，需要你完成人脸识别，操作完成后，资金将在10分钟内打款到您的指定账户。
            </div>
          </div>
        </div> -->
        </div>
        <!-- 标题2 -->
        <!-- <div class="u-flex u-col-stretch know-title">
        <div class="u-flex-1 u-flex-col u-row-between know-title-font">
          <div class="font-tit">02.如何还款到吉用花？</div>
        </div>
      </div> -->
        <!-- 内容2 -->
        <!-- <div class="know-cont know-cont2-box">
        <div class="u-flex u-col-center">
          <img
            class="know-cont2-img"
            src="../assets/images/know_2_1.png"
            alt=""
          />
          <div class="know-cont2-tit">方式一：手动还款</div>
        </div>
        <div class="know-cont2-cont">
          您贷款提取完成后，首页会为您生成还款计划，您可以按照还款计划中约定的时间，按照页面指引操作还款，为了避免逾期导致征信不良，建议您开启通知获得还款信息。
        </div>
      </div> -->
        <!-- 内容2 -->
        <!-- <div class="know-cont know-cont2-box">
        <div class="u-flex u-col-center">
          <img
            class="know-cont2-img"
            src="../assets/images/know_2_2.png"
            alt=""
          />
          <div class="know-cont2-tit">方式二：自动还款</div>
        </div>
        <div class="know-cont2-cont">
          在您的贷款申请审核通过后，绑定银行卡进行提款操作时，勾选页面中【同步绑定为还款卡】按钮，同时勾选【三方代扣协议】，我们将为您开通自动还款功能，会根据还款计划自动从绑定的银行卡中扣款，为了避免扣款失败导致的逾期问题，请您在绑定的银行卡中预留足够的资金。
        </div>
      </div> -->
        <!-- 标题3 -->
        <!-- <div class="u-flex u-col-stretch know-title">
        <div class="u-flex-1 u-flex-col u-row-between know-title-font">
          <div class="font-tit">03.如何提升吉用花的额度？</div>
        </div>
      </div> -->
        <!-- 内容3 -->
        <!-- <div class="u-flex u-row-between know-cont3-box">
        <div class="u-flex-col u-col-center">
          <img
            class="know-cont3-img"
            src="../assets/images/know_3_1.png"
            alt=""
          />
          <div class="know-cont3-tit">· 提交补充信息 ·</div>
          <div class="know-cont3-ntit">
            上传证件照 (仅需2分钟)<br />其他补充信息 (仅需1分钟)
          </div>
        </div>
        <div class="u-flex-col u-col-center">
          <img
            class="know-cont3-img"
            src="../assets/images/know_3_2.png"
            alt=""
          />
          <div class="know-cont3-tit">· 保持良好的还款记录 ·</div>
          <div class="know-cont3-ntit">
            获得贷款后定时还款<br />多借几次，好借好还
          </div>
        </div>
      </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Know",
  data: function () {
    return {
      contentList: [
        {
          top: {
            content: "01.如何在吉用花获得贷款",
            des: "仅需 3 步 在吉用花轻松获得最高200,000贷款",
          },
          content: [
            {
              title: "在首页点击提升额度",
              content:
                "在首页点击「提升额度」按钮进入信息采集页面，按照页面中的引导依次如实完成资料填写，这一步大概会让你使用2分钟的时间进行。完成后你有机会获得2张提额券。",
            },
            {
              title: "完成资料提交",
              content:
                "信息采集完成后点击页面中【下一步】按钮提交您的贷款申请，您的贷款申请预计再5分钟内可以完成审核，在此期间建议您开启通知权限，及时获知审核结果。",
            },
            {
              title: "完成提款",
              content:
                "额度审核完成后，在首页点击【提款】按钮，绑定您的银行卡，配合安全方面考虑，需要你完成人脸识别，操作完成后，资金将在10分钟内打款到您的指定账户。",
            },
          ],
        },
        {
          top: {
            content: "02.如何还款到吉用花？",
            des: null,
          },
          content: [
            {
              title: "手动还款",
              content:
                "您贷款提取完成后，首页会为您生成还款计划，您可以按照还款计划中约定的时间，按照页面指引操作还款，为了避免逾期导致征信不良，建议您开启通知获得还款信息。",
            },
            {
              title: "自动还款",
              content:
                "在您的贷款申请审核通过后，绑定银行卡进行提款操作时，勾选页面中「同步绑定为还款卡」按钮，同时勾选同意「三方代扣协议」，我们将为您开通自动还款功能，会根据还款计划自动从绑定的银行卡中扣款，为了避免扣款失败导致的逾期问题，请您在绑定的银行卡中预留足够资金。",
            },
          ],
        },
        {
          top: {
            content: "03.如何提升吉用花的额度？",
            des: null,
          },
          content: [
            {
              title: "确保信息真实有效",
              content:
                "借款人在提交自己的个人信息资料时，确保所填信息真实有效。写的信息越完善，所获得得贷款额度可能就越高。",
            },
            {
              title: "保持良好的还款记录",
              content:
                "良好的还款习惯将提升您的综合信用评分。贷款机构会根据用户的还款记录评定用户的个人信用，保证按时还款，拥有良好的还款记录。",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.know-box {
  .box-title {
    height: 4.52rem;
    padding: 0.55rem 1.46rem;
    background-image: url("../assets/images/know_bc.png");
    background-size: cover;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.27rem;
    color: #181818;
    line-height: 0.38rem;
    letter-spacing: 2px;
    .u-flex {
      margin-bottom: 0.17rem;
    }
    .left {
      background-size: 2.4rem 0.65rem;
      display: inline-block;
      height: 0.65rem;
      width: 2.4rem;
      background-image: url("../assets/images/know_top_left.png");
      margin-right: 0.15rem;
    }
    .right {
      display: inline-block;
      padding-left: 0.15rem;
      font-family: SourceHanSansSC, SourceHanSansSC;
      font-weight: 400;
      font-size: 0.22rem;
      color: #ffffff;
      line-height: 0.33rem;
      height: 0.36rem;
      width: 1.56rem;
      text-align: left;
      font-style: normal;
      background-image: url(data:image/png;base64,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);
      background-size: 1.56rem 0.36rem;
      background-repeat: no-repeat;
      letter-spacing: 0px;
    }
  }
  background-color: #f5f5f5;
  // 有按钮时的padding
  // padding: 0.6rem 0.4rem 2.88rem;
  // 没有按钮时的padding

  .box-main {
    position: relative;
    top: -2.27rem;
    padding: 0 0.22rem 0.6rem 0.25rem;
    .know-content-box {
      padding: 0.43rem 0.4rem 0.51rem 0.37rem;
      border-radius: 0.22rem;
      background: #ffffff;
      margin-bottom: 0.24rem;
      .know-title {
        margin-bottom: 0.15rem;

        // &::before {
        //   display: block;
        //   content: "";
        //   width: 2px;
        //   background: #3563fa;
        // }

        .font-tit {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #3563fa;
          line-height: 0.3rem;
          font-weight: 600;
          font-size: 0.32rem;
          color: #372f2a;
          line-height: 0.45rem;
          text-align: left;
          font-style: normal;
        }

        .font-ntit {
          font-family: PingFangSC, PingFangSC-Regular;
          font-size: 0.24rem;
          color: #7a7d84;
          line-height: 0.33rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.04rem;
        }
      }

      .know-cont {
        padding: 0.36rem 0rem 0.15rem;
        border-radius: 0.12rem;

        .know-cont-tit {
          font-family: PingFangSC, PingFangSC-Medium;
          line-height: 0.4rem;
          font-weight: 600;
          font-size: 0.28rem;
          color: #372f2a;
          .text {
            display: inline-block;
            height: 0.41rem;
            width: 0.41rem;
            text-align: center;
            background-size: 0.41rem 0.41rem;
            background-image: url("../assets/images/know_number.png");
            color: #e71a0f;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.2rem;
            color: #e71a0f;
            background-position-y: 0.02rem;
          }
        }
      }

      .know-cont1-box {
        .know-cont1 {
          margin-bottom: 0.48rem;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .know-cont1-right {
          margin-left: 0.13rem;
        }

        .know-cont1-cont {
          font-size: 0.23rem;
          font-family: PingFangSC, PingFangSC-Regular;
          line-height: 0.33rem;
          margin-top: 0.16rem;
          font-weight: 300;
          color: #7a7d84;
          text-align: justify;
        }
      }

      .know-cont2-box {
        margin-bottom: 0.24rem;

        & + .know-cont2-box {
          margin-bottom: 0.6rem;
        }
        .know-cont2-img {
          display: block;
          width: 0.48rem;
          height: 0.48rem;
          margin-right: 0.16rem;
        }

        .know-cont2-tit {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #111c31;
          line-height: 0.34rem;
        }

        .know-cont2-cont {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: justify;
          color: #868e9e;
          line-height: 0.36rem;
          margin-top: 0.2rem;
        }
      }

      .know-cont3-box {
        .know-cont3-img {
          display: block;
          width: 1.44rem;
          height: 1.44rem;
          margin-bottom: 0.24rem;
        }

        .know-cont3-tit {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #111c31;
          line-height: 0.34rem;
          margin-bottom: 0.14rem;
        }

        .know-cont3-ntit {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: justify;
          color: #868e9e;
          line-height: 0.36rem;
        }
      }
    }
  }
}
</style>
